import React from "react";
import { Modal } from "react-bootstrap";
import { FormProvider, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";

import { Button, CloseButton, HookFormInputGroup } from "components";
import { useCheckFeeTemplateNameMutation } from "queries";
import { uiActions } from "store";
import { required } from "validators/validation";

import styles from "./copyTemplate.module.scss";

const CopyTemplateObsoleteModal = ({
	show,
	onHide,
	onSubmit,
	companyId,
	type,
}) => {
	const dispatch = useDispatch();

	const { mutateAsync: checkFeeTemplateName } =
		useCheckFeeTemplateNameMutation();

	const formMethods = useForm();

	const {
		handleSubmit,
		register,
		setError,
		getValues,
		formState: { errors },
	} = formMethods;

	const _handleSubmit = async form => {
		try {
			dispatch(uiActions.showSpinnerOverlay());
			const { exists } = await checkFeeTemplateName({
				companyId,
				type,
				templateName: getValues("name"),
			});
			if (exists) {
				setError("name", {
					message: "Template name is taken",
				});
			} else {
				await onSubmit(form);
				onHide();
			}
		} finally {
			dispatch(uiActions.hideSpinnerOverlay());
		}
	};

	return (
		<Modal
			className={styles.modal}
			show={show}
			onHide={onHide}
			animation={false}
			centered
		>
			<Modal.Header>
				<Modal.Title className="text-center">Copy Template</Modal.Title>
				<CloseButton onClick={onHide} />
			</Modal.Header>
			<Modal.Body className={styles.body}>
				<FormProvider {...formMethods}>
					<form
						onSubmit={handleSubmit(_handleSubmit)}
						className="d-flex align-items-center flex-column"
					>
						<HookFormInputGroup
							name="name"
							register={register}
							validator={required}
							errors={errors}
							label="New Template`s Name"
							placeholder="Enter Name"
							colInput={12}
							colLabel={12}
							className="mx-0"
						/>
						<Button
							type="submit"
							value="Create copy"
							variant="primary"
							className={styles.copyButton}
						/>
					</form>
				</FormProvider>
			</Modal.Body>
		</Modal>
	);
};

export default CopyTemplateObsoleteModal;
